import { Archive, CheckCircle, Edit, MoreVertical, Send, Trash2, UserPlus, X, Award, LogOut } from "react-feather";
import styles from "./tenantcardheader.module.css";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tooltip } from "@mui/material";
import { useHistory } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";

const TenantCardHeader = ({ tenantData, setTenantData, setLoading, setSnackbarOpen, setSnackbarMsg, setShowAddForm, setActiveTenant, activeTenant, setIsAddForm, setShowMoveoutForm }) => {
  const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
  const redirect = useHistory();
  const [openArchiveModal, setOpenArchiveModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [renewalModalOpen, setRenewalModalOpen] = useState(false);
  const [renewalLinkId, setRenewalLinkId] = useState(0);

  const resendWelcomeEmail = async (tId) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/resend-welcome-email/" + tId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      toast.error("Error occured. Try Again!");
    });
  }

  const sendLeaseRenewalLink = async () => {
    setRenewalModalOpen(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/send-lease-renewal-email/" + renewalLinkId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      toast.error("Error occured. Try Again!");
    });
  }

  const archiveModalOpen = async (tId) => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/tenants/check-before-archive/" + tId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      if (response.data.status === true) {
        setOpenArchiveModal(true);
      } else {
        toast.error(response.data.message);
      }
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  };

  const unArchiveModalOpen = async (tId) => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/tenants/check-before-unarchive/" + tId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      if (response.data.status === true) {
        setOpenArchiveModal(true);
      } else {
        toast.error(response.data.message);
      }
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  }

  const archiveConfirm = async () => {
    setLoading(true);
    setOpenArchiveModal(false);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    let is_archived = 1 - tenantData?.is_archived;
    let curUrl = process.env.REACT_APP_TENANT_API_URL + "v1/tenants/" + tenantData?.id + "/archive";
    if (is_archived === 0) {
      curUrl = process.env.REACT_APP_TENANT_API_URL + "v1/tenants/" + tenantData?.id + "/unarchive";
    }
    if (is_archived === 1) {
      curUrl = process.env.REACT_APP_TENANT_API_URL + "v1/tenants/" + tenantData?.id + "/archive";
    }
    axios.put(curUrl, { is_archived: is_archived }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      setSnackbarOpen(true);
      if (is_archived === 0) {
        setSnackbarMsg("Tenant unarchived successfully. The Lease and associated Rent Roll records will be unarchived immediately");
      } else {
        setSnackbarMsg("Tenant archived successfully. The Lease and associated Rent Roll records will be archived immediately");
      }

      setTenantData((prev) => {
        return { ...prev, is_archived: is_archived };
      });
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  }

  const deleteConfirm = async () => {
    setLoading(true);
    setOpenDeleteModal(false);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    axios.delete(process.env.REACT_APP_TENANT_API_URL + "v1/tenants/" + tenantData?.id, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      setTimeout(() => {
        redirect.push("/people/tenants");
      }, 2000);
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  }


  const addToLeaderBoard = async () => {
    setLoading(true);

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    return axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/add-to-leaderboard/" + tenantData?.id, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);

      setTenantData({ ...tenantData, is_leaderboard: 1 });
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  return (<div className={`${styles.SMProCardHead}`}>
    <div className={tenantData?.all_tenants.length === 3 ? `${styles.SMProPicMainDubble} ${styles.Three}` : tenantData?.all_tenants.length === 2 ? `${styles.SMProPicMainDubble}` : `${styles.SMProPicMain}`}>
      {tenantData?.all_tenants.map((item, index) => {
        return (<Tooltip title={item?.full_name} placement="bottom" onClick={(e) => setActiveTenant(index)}>
          <div className={activeTenant === index ? `${styles.avatar} ${styles.active}` : `${styles.avatar}`}>
            {item?.user_image !== "" ? (<img src={item?.user_image} className={`${styles.roundedcircle}`} alt="" />) : (<p>{item?.initial}</p>)}
          </div>
        </Tooltip>);
      })}
    </div>
    <h5>
      {tenantData?.all_tenants.length > 0 && tenantData?.all_tenants[activeTenant] ? tenantData?.all_tenants[activeTenant]?.full_name : null}
      {tenantData?.all_tenants.length > 0 && tenantData?.all_tenants[activeTenant] && tenantData?.all_tenants[activeTenant]?.verification_status === 1 && (<img src="/static/img/verified.svg" className={`${styles.Varified}`} alt="" />)}
    </h5>
    {tenantData?.is_move_out === 0 && isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant:update") > -1 && <Dropdown className={`${styles.ProEditSec}`}>
      <Dropdown.Toggle className={`${styles.EditActionsBU} ProsDrBU`} id="dropdown-basic">
        <MoreVertical />
      </Dropdown.Toggle>
      <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setShowAddForm(true); setIsAddForm(false); }}>
          <Edit /> Edit
        </Dropdown.Item>}
        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant:update") > -1 && tenantData?.is_archived === 0 && tenantData?.all_tenants?.length < 3 && (<Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setShowAddForm(true); setIsAddForm(true); }}>
          <UserPlus /> New Tenant
        </Dropdown.Item>)}
        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant:update") > -1 && tenantData?.is_archived === 0 && (<Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setShowMoveoutForm(true); }}>
          <LogOut /> Move Out Tenant
        </Dropdown.Item>)}
        {/*isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant:update") > -1 && tenantData?.is_archived === 1 && (<Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => unArchiveModalOpen(tenantData?.id)}>
          <Archive /> Unarchive All
        </Dropdown.Item>)}
        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant:update") > -1 && tenantData?.is_archived === 0 && (<Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => archiveModalOpen(tenantData?.id)}>
          <Archive /> Archive All
        </Dropdown.Item>)*/}
        <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => resendWelcomeEmail(tenantData?.id)}>
          <CheckCircle /> Resend Welcome Email
        </Dropdown.Item>
        <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setRenewalModalOpen(true); setRenewalLinkId(tenantData?.id); }}>
          <Send /> Send Renewal Email
        </Dropdown.Item>
        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant:update") > -1 && !tenantData?.is_leaderboard && (<Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => addToLeaderBoard()}>
          <Award /> Add to Leaderboard
        </Dropdown.Item>)}
        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant:delete") > -1 && (<Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => setOpenDeleteModal(true)}>
          <Trash2 /> Delete All
        </Dropdown.Item>)}
      </Dropdown.Menu>
    </Dropdown>}

    <Dialog
      open={openDeleteModal}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setOpenDeleteModal(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to delete the Tenant Record?
        <button onClick={(e) => setOpenDeleteModal(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The Tenant Record will be removed immediately. This action is irreversible.</label>
            <label className="PopupBodyText">Once deleted, the tenant will be reverted to a prospect.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => deleteConfirm()} className="CancelPopupBU">Delete</Button>
        <Button onClick={(e) => setOpenDeleteModal(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={openArchiveModal}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setOpenArchiveModal(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to{" "}{tenantData?.is_archived ? "unarchive" : "archive"} the Tenant Record?
        <button onClick={(e) => setOpenArchiveModal(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">{tenantData?.is_archived ? "The Tenant Record will be unarchived immediately.You can archive it at any time." : "The Tenant will be moved out and Tenant Record will be archived immediately.You can unarchive it at any time."} </label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="CancelPopupBU" onClick={(e) => archiveConfirm()}>{tenantData?.is_archived ? "Unarchive" : "Archive"}</Button>
        <Button onClick={(e) => setOpenArchiveModal(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={renewalModalOpen}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setRenewalModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to send lease renewal link?
        <button onClick={(e) => setRenewalModalOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">Send lease renewal link to the tenant via email? This will happen immediately and cannot be reversed.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => sendLeaseRenewalLink(e)} className="CancelPopupBU">Confirm</Button>
        <Button onClick={(e) => setRenewalModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

  </div>);
};

export default TenantCardHeader;